(function (Drupal, drupalSettings, $) {
  Drupal.behaviors.global = {
    attach: (context) => {
      if (context === document) {
        colorboxGlobalSettings();
      }

      a11yFixes();
    }
  };

  /**
   * Set the global setting for modals.
   *
   * @return {void};
   */
  function colorboxGlobalSettings() {
    // Common settings.
    // @see https://www.jacklmoore.com/colorbox/
    window.colorboxDefault = {
      inline: true,
      innerWidth: '600',
      maxWidth: '80%',
      maxHeight: '95%',
      opacity: 1,
      overlayClose: true,
      fadeOut: 100,
      closeButton: true,
      close: `<img src="${drupalSettings.path.baseUrl}${drupalSettings.path.themeUrl}/assets/img/icons/close.svg" alt="Fermer la fenêtre" title="Fermer la fenêtre">`,
      onOpen: () => {
        document.body.classList.add('modal-is-open');
      },
      onClosed: () => {
        document.body.classList.remove('modal-is-open');
      }
    };

    // Manage close button.
    const closeTriggerList = document.querySelectorAll('[data-modal-close]');
    if (!closeTriggerList.length) {
      return;
    }

    [].forEach.call(closeTriggerList, (closeBtn) => {
      closeBtn.addEventListener('click', () => {
        $.fn.colorbox.close();
      });
    });
  }
}(Drupal, drupalSettings, jQuery));

/**
 * Get URL params.
 *
 * @param {string} url
 *  URL
 *
 * @return {(array|boolean)};
 */
function getParamList(url) {
  // Remove domain.
  url = url.split('?')[1];

  // No parameters.
  if (!url) {
    return false;
  }

  // Remove anchor.
  url = url.split('#')[0];

  const params = url.split('&');
  const outputParams = [];
  params.forEach((arg) => {
    const p = arg.split('=');
    const obj = {};

    obj.name  = p[0];
    obj.value = p[1];

    outputParams.push(obj);
  });

  return outputParams;
}

/**
 * Get specific parameter.
 *
 * @param {string} name
 *  Parametre name.
 *
 * @return {(string|boolean)} value
 */
window.getParam = function (name) {
  const paramList = getParamList(window.location.href);
  if (!paramList) {
    return false;
  }

  const param = paramList.filter((p) => p.name === name);
  if (!param.length) {
    return false;
  }
  return param[0].value;
};

/**
 * Fix some accessibility issue.
 * @return {void}
 */
function a11yFixes() {
  // Remove emtpy id.
  document.querySelectorAll('script[id]').forEach((scriptTag) => {
    scriptTag.removeAttribute('id');
  });

  // Change hcaptcha iframe title;
  document.querySelectorAll('.h-captcha iframe').forEach((iframe) => {
    iframe.setAttribute('title', 'Captcha de sécurité contenant une case à cocher');
  });
}
